/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import PropTypes from "prop-types";
import { HashLink } from "react-router-hash-link";
// components

// //Examples props declaration
// const buttonScrollToMissionProps = {
//   displayText:"Investment Portfolio",
//   link: "#Mission",
// }
// //Examples usage
// <ScrollSectionButton {...buttonScrollToMissionProps} />

// export default function ScrollSectionButton({ link, webflowanimate }) {
//   return (
//     <span>
//       <style
//         dangerouslySetInnerHTML={{
//           __html: `
//       @import url(/css/normalize.css);
//       @import url(/css/webflow.css);
//       @import url(/css/custom.webflow.css);
//     `,
//         }}
//       />
//       {webflowanimate === true ? (
//         <span className="af-view">
//           <HashLink
//             smooth
//             to={"/" + link}
//             data-w-id="5d772935-4b68-8fc4-5a8d-0f18295a938d"
//             style={{
//               WebkitTransform:
//                 "translate3d(0, 0, 0) scale3d(0.97, 0.97, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
//               MozTransform:
//                 "translate3d(0, 0, 0) scale3d(0.97, 0.97, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
//               msTransform:
//                 "translate3d(0, 0, 0) scale3d(0.97, 0.97, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
//               transform:
//                 "translate3d(0, 0, 0) scale3d(0.97, 0.97, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
//               opacity: 0,
//             }}
//             className="af-class-scroll-down-button af-bottom-right"
//           >
//             <img
//               src="images/ShuttleLogo.png"
//               alt="Space Shuttle Logo"
//               className="af-class-image af-class-scroll-down-button rotate-180 animate-pulse"
//             />
//           </HashLink>
//         </span>
//       ) : (
//         <span className="af-view">
//           <HashLink
//             smooth
//             to={"/" + link}
//             className="af-class-scroll-down-button af-bottom-right animate-xappearfadein"
//           >
//             <img
//               src="images/ShuttleLogo.png"
//               alt="Space Shuttle Logo"
//               className="af-class-image af-class-scroll-down-button rotate-180 animate-pulse"
//             />
//           </HashLink>
//         </span>
//       )}
//     </span>
//   );
// }
// ScrollSectionButton.defaultProps = {
//   link: "#",
//   webflowanimate: true,
// };

// ScrollSectionButton.propTypes = {
//   link: PropTypes.string.isRequired,
//   webflowanimate: PropTypes.bool,
// };

export default function ScrollSectionButton({ link }) {
  return (
    <span className="af-view">
      <HashLink
        smooth
        to={"/" + link}
        className="af-class-scroll-down-button af-bottom-right animate-xappearfadein"
      >
        <img
          src="images/ShuttleLogo.png"
          alt="Space Shuttle Logo"
          className="af-class-image af-class-scroll-down-button rotate-180 animate-pulse"
        />
      </HashLink>
    </span>
  );
}
ScrollSectionButton.defaultProps = {
  link: "#",
};

ScrollSectionButton.propTypes = {
  link: PropTypes.string.isRequired,
};
